/**
 * Retrieves the corresponding workflow handler for a given checklist item.
 * It first attempts to find a handler based on the checklist item's metadata UI component type.
 * If not found, it falls back to the unique step code.
 * 
 * @param workflowHandler The mapping object of workflow handlers
 * @param checklistItem The checklist item record
 * @returns The specific handler action object or null if not found
 */
export const getWorkflowItemHandler = (workflowHandler: any, checklistItem: any) => {
  if (!workflowHandler || !checklistItem) return null;

  try {
    const metadata = typeof checklistItem.metadata === 'string'
      ? JSON.parse(checklistItem.metadata)
      : checklistItem.metadata || {};

    const componentHandler = metadata?.ui?.component?.handler;

    if (componentHandler && workflowHandler[componentHandler]) {
      return workflowHandler[componentHandler];
    }
  } catch (error) {
    console.warn('Error parsing checklist item metadata for workflow action mapping', error);
  }

  // Fallback to checklist item code for backward compatibility
  return workflowHandler[checklistItem.code] || null;
};